import {AppState, EngagementPhase, MessagingCanvasPhase, changeExpandedStatus} from "..";
import {StartChatWithMessagePhase} from "./StartChatWithMessagePhase";
import {Colors, Container} from "@bounce/shared/ui";
import {Box} from "@mui/material";
import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useDrawerHeight} from "~/new-design/hooks/useDrawerHeight";
import {EntryPoint} from "./EntryPoint";
import {PreEngagementChatPhase} from "./PreEngagementChatPhase";
import {useNewDesignEnabled} from "~/new-design";
import {useIsMobile} from "@bounce/shared/consumer/helpers";

const getPhaseComponent = (phase: EngagementPhase) => {
  switch (phase) {
    case EngagementPhase.MessagingCanvas:
      return <MessagingCanvasPhase />;
    case EngagementPhase.Loading:
      return <MessagingCanvasPhase isLoading />;
    case EngagementPhase.StartChatWithMessage:
      return <StartChatWithMessagePhase />;
    case EngagementPhase.PreEngagementChat:
      return <PreEngagementChatPhase />;
    default:
      return <MessagingCanvasPhase isLoading />;
  }
};

export function RootContainer() {
  const dispatch = useDispatch();
  const currentPhase = useSelector((state: AppState) => state.session.currentPhase);
  const expanded = useSelector((state: AppState) => state.session.expanded);

  const drawerHeight = useDrawerHeight();
  const isNewDesignEnabled = useNewDesignEnabled();
  const isMobile = useIsMobile();
  const shouldCenter = isNewDesignEnabled && isMobile;

  const rootRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!expanded) return;
    const handlePointerDown = (event: PointerEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node) && isMobile) {
        dispatch(changeExpandedStatus({expanded: false}));
      }
    };
    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [expanded, dispatch]);

  return (
    <Box ref={rootRef}>
      <Container
        sx={{
          position: "fixed",
          bottom: drawerHeight ? `${drawerHeight}px` : "32px",
          right: shouldCenter ? 0 : "32px",
          left: shouldCenter ? 0 : undefined,
          zIndex: 1000,
          gap: 0,
          transition: "bottom 200ms ease",
        }}
      >
        {expanded && (
          <Container
            sx={{
              boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.25)",
              width: "320px",
              height: "520px",
              mb: "16px",
              borderRadius: "8px",
              backgroundColor: Colors.bw.white,
              gap: 0,
              alignItems: "stretch",
              overflow: "hidden",
            }}
          >
            {getPhaseComponent(currentPhase)}
          </Container>
        )}
        <EntryPoint />
      </Container>
    </Box>
  );
}
